import React from 'react';

const IconDisabledFlag = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
    >
      <path
        d='M15.6644 6.0273L4.16438 2.0273C4.089 2.00107 4.00844 1.99325 3.92943 2.00452C3.85042 2.01578 3.77525 2.0458 3.71022 2.09205C3.64518 2.13831 3.59216 2.19946 3.55558 2.2704C3.51901 2.34133 3.49995 2.41999 3.5 2.4998L3.5 13.4998C3.5 13.6324 3.55268 13.7596 3.64645 13.8534C3.74021 13.9471 3.86739 13.9998 4 13.9998C4.13261 13.9998 4.25979 13.9471 4.35355 13.8534C4.44732 13.7596 4.5 13.6324 4.5 13.4998L4.5 10.8554L15.6644 6.9723C15.7626 6.9383 15.8478 6.87452 15.9081 6.78983C15.9684 6.70514 16.0008 6.60377 16.0008 6.4998C16.0008 6.39584 15.9684 6.29446 15.9081 6.20977C15.8478 6.12509 15.7626 6.06131 15.6644 6.0273ZM4.5 9.79668L4.5 3.20293L13.9781 6.4998L4.5 9.79668Z'
        fill='#EAEAEA'
      />
    </svg>
  );
};

export default IconDisabledFlag;
